var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.4,
    height: 16,
    viewBox: "0 0 14.4 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icons8-purchase-order_1_",
    "data-name": "icons8-purchase-order (1)",
    d: "M8.086,5A1.883,1.883,0,0,0,6.234,6.895v9.895H5.617A.625.625,0,0,0,5,17.421v.842A2.716,2.716,0,0,0,7.674,21h9.051A2.716,2.716,0,0,0,19.4,18.263V6.895A1.883,1.883,0,0,0,17.549,5Zm0,1.263h9.463a.615.615,0,0,1,.617.632V18.263a1.44,1.44,0,1,1-2.88,0v-.842a.625.625,0,0,0-.617-.632h-7.2V6.895A.615.615,0,0,1,8.086,6.263ZM9.731,8.368A.632.632,0,1,0,10.349,9,.624.624,0,0,0,9.731,8.368Zm2.057,0a.632.632,0,0,0,0,1.263H15.9a.632.632,0,0,0,0-1.263ZM9.731,10.895a.632.632,0,1,0,.617.632A.624.624,0,0,0,9.731,10.895Zm2.057,0a.632.632,0,0,0,0,1.263H15.9a.632.632,0,0,0,0-1.263ZM9.731,13.421a.632.632,0,1,0,.617.632A.624.624,0,0,0,9.731,13.421Zm2.057,0a.632.632,0,0,0,0,1.263H15.9a.632.632,0,0,0,0-1.263ZM6.234,18.053h7.817v.211a2.7,2.7,0,0,0,.483,1.474H7.674a1.448,1.448,0,0,1-1.44-1.474Z",
    transform: "translate(-5 -5)",
    fill: "#2a60bc"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/Add.ac0fd23cec4999bedac13265e755084e.svg";
export { ForwardRef as ReactComponent };